var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_c('RemoveWorkspaceDialogConfirmation'),_c('div',{staticClass:"snackbar-container"},_vm._l((_vm.snackbars),function(snackbar,index){return _c('div',{key:("snackbar-" + index),staticClass:"snackbar",class:{
        info: snackbar.type === 'info',
        fail: snackbar.type === 'fail',
        success: snackbar.type === 'success',
      }},[_vm._v(" "+_vm._s(snackbar.data)+" ")])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }